<template>
  <div class="create-batch-check-order-job">
    <div class="content flex-ct between" style="min-height: 0">
      <a-tabs default-active-key="InvoiceInfo" @change="changeTabs">
        <a-tab-pane key="InvoiceInfo" :tab="$t(`发票信息`)"></a-tab-pane>
        <a-tab-pane key="SellerInfo" :tab="$t(`开票人信息`)"></a-tab-pane>
        <a-tab-pane key="BuyerInfo" :tab="$t(`购买方信息`)"></a-tab-pane>
        <a-tab-pane key="ProductInfo" :tab="$t(`商品信息`)"></a-tab-pane>
        <a-tab-pane
          key="PayableListInfo"
          :tab="$t(`关联订单信息`)"
          v-if="showMappingList.length > 0"
        ></a-tab-pane>
      </a-tabs>
      <div class="btns flex-ct">
        <a-button
          type="primary"
          v-if="['PART_WRITTEN_OFF', 'WAIT_WRITTEN_OFF'].includes(formData.status)"
          @click="bindOrderHandle"
        >
          {{ $t('关联应付订单') }}
        </a-button>
        <OperateBtn
          class="ml10"
          v-if="formData.status === 'WAIT_CHECK'"
          api="checkInvoice"
          :text="$t('审核')"
          :params="{
            invoiceIdList: [id],
          }"
          @success="init"
        />
      </div>
    </div>
    <div class="content-overflow">
      <section class="left-div fixContent" :style="{ height: scrollHeight }">
        <a-form-model ref="ruleForm" :model="formData">
          <ModalBox
            id="InvoiceInfo"
            :title="$t('发票信息')"
            :showCopy="isDetail"
            @copyOrder="copyOrder"
          >
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-model-item required :label="$t(`发票号码`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.invoiceNo"
                    :placeholder="$t(`请输入发票号码`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item required :label="$t(`发票代码`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.invoiceCode"
                    :placeholder="$t(`请输入发票代码`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`开票日期`)" required>
                  <DatePicker
                    :needhms="false"
                    style="background-color: #ffffff; width: 100%"
                    :init-date-time="formData.invoiceDate"
                    @choose="chooseOrderDate"
                    :disabled="isDisabled"
                    :placehold="$t(`请选择开票日期`)"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item required :label="$t(`发票类型`)">
                  <SelectInvoiceType :code.sync="formData.invoiceType" :disabled="isDisabled" />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item required :label="$t(`发票状态`)">
                  <a-input :value="$t(invoiceStatusMapping[formData.status])" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`结算组织`)" required>
                  <CommonSelect
                    :isBu="true"
                    :list="$store.state.settlementBuList"
                    :disabled="isDisabled"
                    :code.sync="formData.businessUnitCode"
                    :name.sync="formData.businessUnitName"
                    @change="changeBU"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="6" v-if="formData.bizType === 'PURCHASE'">
                <a-form-model-item required :label="$t(`供应商`)">
                  <CommonQuerySelect
                    :key="`supplier-${formData.bizType}`"
                    api="queryPurchaseSupplierList"
                    :params="{
                      status: 1,
                    }"
                    :placeholder="$t(`供应商`)"
                    :code.sync="formData.sellerCode"
                    :name.sync="formData.sellerName"
                    :disabled="isDisabled"
                    valueName="supplier_code"
                    labelName="supplier_name"
                    @change="supplierIndexChange"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="6" v-else>
                <a-form-model-item :label="$t(`结算客户`)" required>
                  <CommonQuerySelect
                    :key="`customer-${formData.bizType}`"
                    api="getAccountDimensionItemList"
                    :disabled="isDisabled"
                    :code.sync="formData.buyerCode"
                    :name.sync="formData.buyerName"
                    :params="{
                      businessUnitCode: formData.businessUnitCode,
                      type: 'customer',
                    }"
                    :placeholder="$t(`结算客户`)"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`结算货币`)" required>
                  <SelectCurrency :code.sync="formData.settlementCurrency" :disabled="isDisabled" />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`商品金额`)">
                  <a-input v-model="formData.amountWithoutTax" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`税率`)">
                  <a-input-number
                    :disabled="isDisabled"
                    style="width: 100%"
                    v-model="formData.taxRate"
                    @change="changeTaxRate"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`税额`)">
                  <a-input v-model="formData.taxAmount" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`总计金额`)">
                  <a-input v-model="formData.amountWithTax" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`备注`)">
                  <a-input v-model="formData.remark" :disabled="isDisabled" />
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`业务类型`)">
                  <a-input :value="$t(invoiceBizTypeMapping[formData.bizType])" :disabled="true" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-model-item :label="$t('发票文件')">
                  <template v-if="formData.url">
                    <img
                      :src="formData.url"
                      alt=""
                      style="width: 100px; height: 100px; object-fit: cover"
                      @click="handlePreview"
                    />
                    <a-icon
                      v-if="!isDisabled"
                      type="delete"
                      class="ml10"
                      style="color: red; cursor: pointer"
                      @click="
                        () => {
                          formData.url = ''
                        }
                      "
                    />
                  </template>
                  <a-upload
                    v-else
                    accept="image/*,.pdf"
                    :disabled="isDisabled"
                    :show-upload-list="false"
                    class="avatar-uploader"
                    :before-upload="beforeUpload"
                    :custom-request="changeUpload"
                  >
                    <a-button :disabled="isDisabled">
                      <a-icon type="upload" />
                      {{ $t('选择文件') }}
                    </a-button>
                  </a-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </ModalBox>
          <ModalBox id="SellerInfo" :title="$t('开票人信息')">
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-model-item :label="$t(`姓名`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.sellerName"
                    :placeholder="$t(`请输入姓名`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`电话`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.sellerMobile"
                    :placeholder="$t(`请输入电话`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`银行开户行名称`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.sellerBankName"
                    :placeholder="$t(`请输入银行开户行名称`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`银行账号`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.sellerBankAccount"
                    :placeholder="$t(`请输入银行账号`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`纳税人识别号`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.sellerTaxpayerCode"
                    :placeholder="$t(`请输入纳税人识别号`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </ModalBox>
          <ModalBox id="BuyerInfo" :title="$t('购买方信息')">
            <a-row :gutter="16">
              <a-col :span="6">
                <a-form-model-item :label="$t(`姓名`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.buyerName"
                    :placeholder="$t(`请输入姓名`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`电话`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.buyerMobile"
                    :placeholder="$t(`请输入电话`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`银行开户行名称`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.buyerBankName"
                    :placeholder="$t(`请输入银行开户行名称`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`银行账号`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.buyerBankAccount"
                    :placeholder="$t(`请输入银行账号`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="6">
                <a-form-model-item :label="$t(`纳税人识别号`)">
                  <a-input
                    :disabled="isDisabled"
                    v-model="formData.buyerTaxpayerCode"
                    :placeholder="$t(`请输入纳税人识别号`)"
                  ></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </ModalBox>
          <ModalBox id="ProductInfo" :title="$t('商品信息')">
            <template v-if="!isDisabled">
              <div class="pricing-method flex-ct">
                <a-form-model-item :label="$t(`计价方式`)" required>
                  <a-select
                    :placeholder="$t(`请选择计价方式`)"
                    v-model="calculateTypeNew"
                    style="width: 350px"
                  >
                    <a-select-option value="BY_TOTAL">
                      {{ $t('通过小计计算单价') }}
                    </a-select-option>
                    <a-select-option value="BY_UNIT">
                      {{ $t('通过单价计算小计') }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <div style="display: flex; justify-content: space-between">
                <div style="position: relative; flex: 1; display: flex">
                  <SkuQuickQueryModal style="width: 350px" @selected="handleChangeSku" />
                  <a-button
                    :disabled="isDisabled"
                    type="primary"
                    style="margin-left: 15px"
                    @click="addGoodsToTable"
                  >
                    <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
                    {{ $t('添加') }}
                  </a-button>
                </div>
                <div>
                  <div class="flex-ct txt fz16" style="font-weight: bold">
                    <div class="flex-ct mr30">
                      {{ $t('数量合计') }}: {{ purchaseAllQuantity | toThousands }}
                    </div>
                    <div class="flex-ct mr30">
                      <span>{{ $t('总金额合计') }}:</span>
                      <PriceInput
                        :currency="formData.settlementCurrency"
                        :value="purchaseAllAmount"
                        :showTxt="true"
                      />
                    </div>
                    <div class="flex-ct">
                      <span>{{ $t('总价税合计') }}:</span>
                      <PriceInput
                        :currency="formData.settlementCurrency"
                        :value="totalPayableAmount"
                        :showTxt="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="table-wrapper" style="margin-top: 10px">
              <a-table
                :columns="columns"
                :dataSource="tableData"
                bordered
                size="middle"
                :loading="tableLoading"
                :pagination="false"
                :scroll="{ x: 1500 }"
                :rowKey="(record, index) => index"
              >
                <span slot="no" slot-scope="text, record, index">
                  {{ index + 1 }}
                </span>
                <span slot="productName" slot-scope="text, record">
                  <div v-if="record.invoiceItemName" class="flex-ct">
                    <span>{{ $t('名称') }}:</span>
                    <a-input
                      :disabled="isDisabled"
                      style="width: 180px; flex: 1"
                      v-model="record.invoiceItemName"
                    />
                  </div>
                  <div v-if="record.gtin">{{ $t('代码') }}:{{ record.gtin }}</div>
                </span>
                <span slot="unit" slot-scope="text, record">
                  <SelectUnit
                    :disabled="isDisabled"
                    :list="record.unitList"
                    :code.sync="record.unit"
                  />
                </span>
                <template slot="productStyle" slot-scope="text, record">
                  <a-input :disabled="isDisabled" v-model="record.invoiceItemStyle" />
                </template>
                <template slot="taxRate" slot-scope="text, record, index">
                  <a-input-number
                    :placeholder="$t(`请输入`)"
                    :formatter="Formatter"
                    :parser="Formatter"
                    :value="text"
                    :disabled="!!formData.taxRate || isDisabled"
                    @blur="(e) => handleChange(e.target.value, 'taxRate', index)"
                  />
                </template>
                <template slot="taxAmount" slot-scope="text">
                  <PriceInput
                    :currency="formData.settlementCurrency"
                    :value="text"
                    :showTxt="true"
                  />
                </template>
                <template slot="amountWithTax" slot-scope="text">
                  <PriceInput
                    :currency="formData.settlementCurrency"
                    :value="text"
                    :showTxt="true"
                  />
                </template>
                <template v-for="col in customRenderList" v-slot:[col]="text, record, index">
                  <div :key="col">
                    <!-- includes 用来判断当前的输入类型 -->
                    <div v-if="!isDisabled">
                      <a-input-number
                        :placeholder="$t(`请输入`)"
                        :formatter="Formatter"
                        :parser="Formatter"
                        v-if="col === 'quantity'"
                        :value="text"
                        @blur="(e) => handleChange(e.target.value, col, index)"
                      />
                      <PriceInput
                        v-else-if="col === 'unitPrice'"
                        :placeholder="$t(`请输入`)"
                        :disabled="calculateTypeNew === 'BY_TOTAL'"
                        :value="text"
                        @blur="(value) => handleChange(value, col, index)"
                      />
                      <PriceInput
                        v-else-if="col === 'amountWithoutTax'"
                        :placeholder="$t(`请输入`)"
                        :disabled="calculateTypeNew === 'BY_UNIT'"
                        :value="text"
                        @blur="(value) => handleChange(value, col, index)"
                      />
                      <a-input
                        :placeholder="$t(`请输入`)"
                        v-else-if="inputScopedSlots.includes(col)"
                        :value="text"
                        @change="(e) => handleChange(e.target.value, col, index)"
                      />
                      <a v-else-if="col === 'action'" @click="onDelect(index)">
                        <a-icon type="delete" style="color: red" />
                      </a>
                      <span v-else>{{ text | toThousands }}</span>
                    </div>
                    <span v-else-if="col === 'quantity'">
                      {{ text }}
                    </span>
                    <span v-else>
                      <PriceInput
                        :currency="formData.settlementCurrency"
                        :value="text"
                        :showTxt="true"
                      />
                    </span>
                  </div>
                </template>
              </a-table>
            </div>
          </ModalBox>
          <ModalBox
            id="PayableListInfo"
            :title="$t('关联订单信息')"
            v-if="showMappingList.length > 0"
          >
            <div class="table-content">
              <div class="table-body">
                <a-table
                  :columns="tableColumns"
                  :data-source="showMappingList"
                  rowKey="orderSn"
                  :pagination="false"
                >
                  <template slot="amount" slot-scope="text, record">
                    <PriceInput
                      style="width: 300px"
                      :value.sync="record.amount"
                      :currency="record.currency"
                      :disabled="!record.canEdit"
                    />
                  </template>
                  <template slot="orderSn" slot-scope="text, record">
                    <span class="text-link">{{ text || record.bizOrderSn }}</span>
                  </template>
                  <template slot="action" slot-scope="text, record">
                    <template v-if="record.canEdit">
                      <a-icon type="check" class="text-link" @click="onSave(record)" />
                      <a-icon type="close" class="text-link ml10" @click="init" />
                    </template>
                    <a @click="editHandle(record)" v-else>
                      <a-icon type="edit" class="text-link" />
                    </a>
                    <a @click="onDelect2(record)" v-if="!isDisabled">
                      <a-icon type="delete" style="color: red" />
                    </a>
                  </template>
                </a-table>
              </div>
            </div>
          </ModalBox>
        </a-form-model>
      </section>
    </div>
    <BottomBtns
      :isEdit.sync="isEdit"
      :isDetail="isDetail"
      :draftLoading="draftLoading"
      :saveLoading="saveLoading"
      :status="formData.status"
      @submit="onSubmit"
      @cancel="getInvoiceDetail"
      @back="backForm"
    />

    <a-modal width="80%" :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="example" style="width: 100%" :src="formData.url" />
    </a-modal>

    <BindPayableOrder
      :visible.sync="bindOrderVisible"
      :info="formData"
      :supplierCode="formData.sellerCode"
      :supplierName="formData.sellerName"
      :bindList.sync="formData.mappingList"
      @refresh="getInvoiceDetail"
      @goToBottom="scrollToBottom"
    />
  </div>
</template>

<script>
import moment from 'moment'
import http from '@/service/axios'
import api from '@/service/api'
import { Modal } from 'ant-design-vue'
import { mapState, mapGetters } from 'vuex'
import DatePicker from '@component/datePicker'
import SelectInvoiceType from '@component/selectInvoiceType'
import SkuQuickQueryModal from '@component/skuQuickQueryModal'
import SelectUnit from '@component/selectUnit'
import SelectCurrency from '@component/selectCurrency'
import BindPayableOrder from '@component/bindPayableOrder'
import BottomBtns from '@component/bottomBtns'
import debounce from '@/common/debounce'
import formatter from '@/common/formatter'
import { add, divide, multiply } from '@/common/number'
import { toFixedUp, convertKeysToCamelCase, goBack } from '@/common'
import deepClone from '@/common/deepClone'
export default {
  name: 'InvoiceDetail',
  components: {
    DatePicker,
    SelectInvoiceType,
    SkuQuickQueryModal,
    SelectUnit,
    BindPayableOrder,
    SelectCurrency,
    BottomBtns,
  },
  data() {
    return {
      id: '',
      isDetail: false,
      isCopy: false,
      isEdit: false,
      formData: {
        bizType: undefined,
        mappingList: [],
        businessUnitCode: undefined,
        businessUnitName: undefined,
        functionalCurrency: undefined,
        buyerName: undefined,
        buyerCode: undefined,
        buyerMobile: undefined,
        buyerBankName: undefined,
        buyerBankAccount: undefined,
        buyerTaxpayerCode: undefined,
        sellerName: undefined,
        sellerCode: undefined,
        sellerBankName: undefined,
        sellerBankAccount: undefined,
        sellerMobile: undefined,
        sellerTaxpayerCode: undefined,
        settlementCurrency: 'CNY',
        status: 'DRAFT',
      },
      pageNo: 1,
      pageSize: 20,
      loading: false,
      saveLoading: false,
      draftLoading: false,
      tableData: [],
      tableLoading: false,
      calculateTypeNew: 'BY_TOTAL',
      currentGood: {},
      purchaseAllQuantity: 0,
      purchaseAllAmount: 0,
      totalPayableAmount: 0,
      customRenderList: ['quantity', 'unitPrice', 'currency', 'delect', 'amountWithoutTax'],
      // 用来匹配插槽中显示input框
      inputScopedSlots: ['quantity', 'unitPrice', 'amountWithoutTax'],
      fileInfo: {},
      previewVisible: false,
      bindOrderVisible: false,
    }
  },
  provide() {
    return {
      page: 'invoiceDetail',
    }
  },
  activated() {
    this.init()
  },
  beforeRouteUpdate(to, from, next) {
    Object.assign(this.$data, this.$options.data())
    this.$nextTick(() => {
      this.init()
    })
    next()
  },
  computed: {
    ...mapState(['currencyMap']),
    ...mapGetters(['invoiceStatusMapping', 'invoiceBizTypeMapping']),
    scrollHeight() {
      let height = window.innerHeight - 280
      return height * this.$store.state.rate + 'px'
    },
    columns() {
      let list = [
        {
          title: 'NO',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        {
          title: this.$t('商品信息'),
          dataIndex: 'productName',
          width: 200,
          scopedSlots: {
            customRender: 'productName',
          },
        },
        {
          title: this.$t('商品规格'),
          align: 'center',
          dataIndex: 'productStyle',
          width: 120,
          scopedSlots: {
            customRender: 'productStyle',
          },
        },
        {
          align: 'center',
          dataIndex: 'unit',
          width: 100,
          title: this.$t('单位'),
          scopedSlots: {
            customRender: 'unit',
          },
        },
        {
          title: this.$t('数量'),
          align: 'center',
          dataIndex: 'quantity',
          width: 120,
          scopedSlots: {
            customRender: 'quantity',
          },
        },
        {
          title: this.$t('单价'),
          align: 'center',
          dataIndex: 'unitPrice',
          width: 120,
          scopedSlots: {
            customRender: 'unitPrice',
          },
        },
        {
          title: this.$t('税率') + '(%)',
          align: 'center',
          dataIndex: 'taxRate',
          width: 120,
          scopedSlots: {
            customRender: 'taxRate',
          },
        },
        {
          title: this.$t('税额'),
          align: 'center',
          dataIndex: 'taxAmount',
          width: 120,
          scopedSlots: {
            customRender: 'taxAmount',
          },
        },
        {
          title: this.$t('金额'),
          align: 'center',
          dataIndex: 'amountWithoutTax',
          width: 120,
          scopedSlots: {
            customRender: 'amountWithoutTax',
          },
        },
        {
          title: this.$t('价税总计'),
          align: 'center',
          dataIndex: 'amountWithTax',
          width: 120,
          scopedSlots: {
            customRender: 'amountWithTax',
          },
        },
        {
          title: this.$t('操作'),
          align: 'center',
          dataIndex: 'action',
          width: 120,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]
      return list
    },
    tableColumns() {
      let list = [
        {
          dataIndex: 'orderSn',
          title: this.$t('应付单号'),
          scopedSlots: {
            customRender: 'orderSn',
          },
        },
        {
          dataIndex: 'amount',
          title: this.$t('金额'),
          scopedSlots: {
            customRender: 'amount',
          },
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 120,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]
      return list
    },
    isDisabled() {
      return this.isDetail && !this.isEdit
    },
    showMappingList() {
      return this.formData.mappingList?.filter((item) => item.status !== -1) || []
    },
  },
  methods: {
    Formatter: formatter,
    init() {
      this.isDetail = false
      this.isCopy = false
      let invoiceFormdata = localStorage.getItem('invoiceFormdata'),
        payableOrderPushdata = localStorage.getItem('payableOrderPushdata') //应付单下推生成的
      if (this.$route.query.id) {
        this.id = this.$route.query.id
        this.isDetail = true
        this.getInvoiceDetail()
      } else {
        this.reset()
        this.formData.bizType = this.$route.query.bizType
        this.formData.invoiceDate = moment().format('YYYY-MM-DD')
      }
      if (invoiceFormdata) {
        this.isCopy = true
        let data = JSON.parse(invoiceFormdata)
        this.formData = data
        this.formData.id = undefined
        this.formData.invoiceNo = undefined
        this.formData.invoiceCode = undefined
        this.formData.mappingList = []
        this.formData.status = 'DRAFT'
        this.tableData = deepClone(this.formData.tableData)
        delete this.formData.tableData
        localStorage.removeItem('invoiceFormdata')
        this.$nextTick(() => {
          this.calcAmount()
        })
      } else if (payableOrderPushdata) {
        this.isCopy = true
        let data = JSON.parse(payableOrderPushdata)
        console.log('payableOrderPushdata: ', data)
        delete data.id
        this.formData.status = 'DRAFT'
        this.tableData = deepClone(data).map((item) => {
          let obj = {
            ...item,
            invoiceItemName: item.itemName,
            invoiceItemStyle: item.itemStyle,
            amountWithTax: item.payableAmount,
          }
          if (typeof item.unitList === 'string') {
            obj.unitList = JSON.parse(item.unitList)
          }
          return obj
        })
        localStorage.removeItem('payableOrderPushdata')
        this.$nextTick(() => {
          this.calcAmount()
        })
      }
    },
    changeBU(value) {
      this.formData.businessUnitCode = value.code
      this.formData.businessUnitName = value.name
      this.formData.functionalCurrency = value.currency
      if (this.formData.bizType === 'PURCHASE') {
        this.formData.buyerName = value.name
        this.formData.buyerCode = value.code
        this.formData.buyerMobile = value.mobile
        this.formData.buyerBankName = value.bank_name
        this.formData.buyerBankAccount = value.bank_account
        this.formData.buyerTaxpayerCode = value.taxpayer_identification_no
      } else {
        this.formData.sellerName = value.name
        this.formData.sellerCode = value.code
        this.formData.sellerMobile = value.mobile
        this.formData.sellerBankName = value.bank_name
        this.formData.sellerBankAccount = value.bank_account
        this.formData.sellerTaxpayerCode = value.taxpayer_identification_no
      }
    },
    getInvoiceDetail() {
      http({
        url: api.getInvoiceDetail,
        data: {
          invoiceId: this.id,
        },
        hasLoading: true,
        success: (res) => {
          let result = convertKeysToCamelCase(res.result)
          this.formData = result
          this.tableData = result.invoiceDetailList
          this.$nextTick(() => {
            this.calcAmount()
          })
        },
      })
    },
    chooseOrderDate(data) {
      this.formData.invoiceDate = data.data
    },
    backForm(back = 0) {
      goBack('invoiceList', back)
    },
    changeTabs(value) {
      document.querySelector(`#${value}`).scrollIntoView(true)
    },
    supplierIndexChange(val) {
      this.formData.sellerBankName = val.bank_name
      this.formData.sellerBankAccount = val.bank_account
      this.formData.sellerMobile = val.mobile
      this.formData.sellerTaxpayerCode = val.taxpayer_identification_no
    },
    handleChange(value, colName, index) {
      const newData = [...this.tableData]
      const target = newData[index]
      if (target) {
        target[colName] = value
        this.calcAmount()
        this.tableData = newData
      }
    },
    calcAmount() {
      this.getTheAmountInPcFn()
      this.calcAllAmount()
    },
    calcAllAmount() {
      let quantity = 0,
        amount = 0,
        amountWithTax = 0
      this.tableData.forEach((item) => {
        quantity = add(quantity, item.quantity)
        amount = add(amount, item.amountWithoutTax)
        amountWithTax = add(amountWithTax, item.amountWithTax)
      })
      this.purchaseAllQuantity = quantity
      this.purchaseAllAmount = amount
      this.totalPayableAmount = amountWithTax
    },
    onDelect(index) {
      this.tableData.splice(index, 1)
      this.$nextTick(() => {
        this.calcAmount()
      })
    },
    onDelect2(record) {
      record.amount = 0
      this.$set(record, 'status', -1)
    },
    handleChangeSku(data) {
      this.currentGood = {
        amountWithTax: '',
        amountWithoutTax: '',
        baseUnit: '',
        discountAmount: '',
        discountRate: '',
        gtin: data.goodsCode,
        itemName: data.goodsName,
        invoiceItemName: data.goodsName,
        skuStyleList: Object.entries(data.selectedSpecs || {}).map(([key, value]) => {
          return {
            name: key,
            styleValue: value,
          }
        }),
        quantity: '',
        unit: '',
        taxAmount: '',
        taxRate: this.formData.taxRate,
        unitPrice: '',
        unitPriceWithTax: '',
        unitList: data.unitList || [],
      }
    },
    addGoodsToTable() {
      if (this.currentGood.itemName) {
        let itemStyle = this.currentGood.skuStyleList.map((item) => item.styleValue).join(';')
        this.currentGood.itemStyle = itemStyle
        this.currentGood.invoiceItemStyle = itemStyle
        let procurementUnitItem =
            this.currentGood.unitList?.find((item) => item.procurementUnit) || {},
          baseUnitItem = this.currentGood.unitList?.find((item) => item.baseUnit) || {}
        this.currentGood.unit = procurementUnitItem.unitNameFull || baseUnitItem.unitNameFull
        if (
          this.tableData.length &&
          this.tableData.findIndex((i) => i.gtin == this.currentGood.gtin) !== -1
        ) {
          return this.$message.error(this.$t('该商品已存在，不可重复添加'))
        }
        this.tableData.push(this.currentGood)
        this.scrollToBottom()
      }
    },
    // 以pc获取金额
    getTheAmountInPcFn() {
      if (!this.tableData.length) {
        this.formData.amountWithoutTax = 0
        this.formData.taxAmount = 0
        this.formData.amountWithTax = 0
        return
      }
      let hasEmpty = false
      let sum = 0,
        taxTotal = 0
      this.tableData.forEach((item) => {
        if (item.quantity && (item.unitPrice || item.amountWithoutTax)) {
          //修改单价和数量 小计跟着改
          if (this.calculateTypeNew === 'BY_TOTAL') {
            item.unitPrice = toFixedUp(divide(item.amountWithoutTax, item.quantity), 4)
          } else {
            item.amountWithoutTax = multiply(item.unitPrice, item.quantity).toFixed(4)
          }
          sum += item.amountWithoutTax * 1
        } else {
          hasEmpty = true
        }
        if (item.amountWithoutTax && item.taxRate) {
          let taxAmount = Number(((item.amountWithoutTax * item.taxRate) / 100).toFixed(4))
          this.$set(item, 'taxAmount', taxAmount)
          taxTotal += taxAmount
          item.amountWithTax = +add(item.amountWithoutTax, taxAmount).toFixed(4)
        }
      })
      if (hasEmpty) return

      this.formData.amountWithoutTax = +sum.toFixed(4)
      this.formData.taxAmount = taxTotal
      this.setTotalAmount()
    },
    setTotalAmount() {
      let result = this.formData.amountWithoutTax * 1 + this.formData.taxAmount * 1
      this.formData.amountWithTax = isNaN(result) ? '' : +result.toFixed(4)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        document.querySelector('.fixContent').scrollTo(0, 2000)
      })
    },
    changeTaxRate: debounce(function (value) {
      this.$nextTick(() => {
        this.tableData.forEach((item) => {
          this.$set(item, 'taxRate', value)
        })
        this.calcAmount()
      })
    }),
    beforeUpload(file) {
      this.fileInfo = file
    },
    async changeUpload() {
      await http({
        url: api.filePreUpload,
        data: {
          file_name: this.fileInfo.name,
          appCode: 'FMS',
          'Content-Type': 'image/*',
        },
        success: (res) => {
          fetch(res.result.upload_url, {
            method: 'PUT',
            body: this.fileInfo,
            headers: {
              'Content-Type': res.result.content_type,
            },
          })
          this.$set(this.formData, 'url', res.result.url)
        },
      })
    },
    onSubmit: debounce(async function (status) {
      const list = this.tableData.map((item) => ({
        amountWithTax: item.amountWithTax,
        amountWithoutTax: item.amountWithoutTax,
        gtin: item.gtin,
        invoiceItemName: item.invoiceItemName,
        invoiceItemStyle: item.invoiceItemStyle,
        itemName: item.itemName,
        itemStyle: item.itemStyle,
        quantity: item.quantity,
        taxAmount: item.taxAmount,
        taxRate: item.taxRate,
        unit: item.unit,
        unitPrice: item.unitPrice,
      }))
      const data = {
        ...deepClone(this.formData),
        merchantCode: this.$store.state.userSession.merchantCode,
        invoiceItemList: list,
      }
      delete data.mappingList
      if (this.id) {
        data.id = this.id
      }
      data.status = status
      console.log('data: ', data)
      if (status === 'DRAFT') {
        this.draftLoading = true
      } else {
        this.saveLoading = true
      }
      try {
        await http({
          url: api.createOrUpdateInvoice,
          data,
          success: async (res) => {
            if (res.success) {
              if (this.$route.query.id) {
                await this.modifyBindList()
                this.$message.success(this.$t('保存成功'))
                this.init()
              } else if (status === 'WAIT_CHECK') {
                if (this.formData.mappingList?.length > 0) {
                  await this.bindHandle(res.result.invoice_id)
                }
                this.$success({
                  title: this.$t(`成功`),
                  content: this.$t(`创建成功`),
                })
                if (this.isDetail) {
                  this.init()
                } else {
                  this.backForm()
                }
              } else {
                this.$message.success({
                  title: this.$t(`成功`),
                  content: this.$t(`暂存成功`),
                })
              }
            }
          },
          fail: (err) => {
            this.$message.error(err.msg)
          },
        })
      } finally {
        this.saveLoading = false
        this.draftLoading = false
      }
    }),
    async bindHandle(invoiceId) {
      await http({
        url: api.bindInvoicePayable,
        data: {
          invoiceId,
          mappingList: this.formData.mappingList,
        },
      })
    },
    reset() {
      Object.assign(this.$data, this.$options.data())
    },
    cancelEdit() {
      this.isEdit = false
      this.getInvoiceDetail()
    },
    handlePreview() {
      this.previewVisible = true
    },
    bindOrderHandle() {
      this.bindOrderVisible = true
    },
    goToPay() {
      Modal.confirm({
        title: this.$t('是否确认支付?'),
        onOk: () => {
          http({
            url: api.payInvoice,
            data: {
              invoiceId: this.formData.id,
            },
            success: () => {
              this.$message.success(this.$t('支付成功'))
              this.getInvoiceDetail()
            },
          })
        },
      })
    },
    cancelPay() {
      Modal.confirm({
        title: this.$t('是否确认取消支付?'),
        onOk: () => {
          http({
            url: api.rejectPayInvoice,
            data: {
              invoiceId: this.formData.id,
            },
            success: () => {
              this.$message.success(this.$t('取消支付成功'))
              this.getInvoiceDetail()
            },
          })
        },
      })
    },
    copyOrder() {
      this.formData.tableData = this.tableData
      let data = JSON.stringify(this.formData)
      localStorage.setItem('invoiceFormdata', data)
      this.$router.push('/invoiceManage/invoiceDetail')
    },
    async modifyBindList() {
      let mappingList = this.formData.mappingList.map((item) => ({
        amount: item.amount,
        orderId: item.id,
        orderSn: item.orderSn,
      }))
      await http({
        url: api.modifyInvoiceAmount,
        data: {
          invoiceId: this.formData.id,
          mappingList,
        },
      })
    },
    editHandle(record) {
      this.$set(record, 'canEdit', true)
    },
    async onSave(record) {
      await this.modifyBindList()
      this.$set(record, 'canEdit', false)
      this.$message.success(this.$t('保存成功'))
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-form-item {
  margin-bottom: 0;
}
.infoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fixContent {
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 16px 0;
}
.modalBox {
  margin-bottom: 10px;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
}
.ant-upload ::v-deep img {
  width: 100px;
  height: 100px;
}
</style>
